export const ActionTypes = {
    ADD_STATION_SALE_MODE: "ADD_STATION_SALE_MODE",
    EDIT_STATION_SALE_MODE: "EDIT_STATION_SALE_MODE",
    DELETE_STATION_SALE_MODE: "DELETE_STATION_SALE_MODE",
    CLEAR_STATION_SALES: "CLEAR_STATION_SALES",
    OPEN_STATION_SALE_SNACK: "OPEN_STATION_SALE_SNACK",
    CLOSE_STATION_SALE_SNACK: "CLOSE_STATION_SALE_SNACK",
    GET_STATION_SALES: "GET_STATION_SALES",
    GET_STATION_SALES_ACCOUNT_DETAILS: "GET_STATION_SALES_ACCOUNT_DETAILS",
    GET_STATION_SALES_PAYMENTS_TYPES: "GET_STATION_SALES_PAYMENTS_TYPES",
    SET_STATION_SALES_FILTERS: "SET_STATION_SALES_FILTERS",
    STATION_SALE_SELECTED: "STATION_SALE_SELECTED",
    RESET_STATION_SALE_SELECTED: "RESET_STATION_SALE_SELECTED",
    CREATE_STATION_SALE: "CREATE_STATION_SALE",
    MOD_STATION_SALE: "MOD_STATION_SALE",
    DELETE_STATION_SALE: "DELETE_STATION_SALE",
    
    SET_CONFIG_PAGE_STATION_SALES: "SET_CONFIG_PAGE_STATION_SALES",
    SET_CONFIG_PAGE_SIZE_STATION_SALES: "SET_CONFIG_PAGE_SIZE_STATION_SALES",
    SET_CONFIG_FILTER_STATION_SALES: "SET_CONFIG_FILTER_STATION_SALES",
    SET_CONFIG_SORTED_STATION_SALES: "SET_CONFIG_SORTED_STATION_SALES",
};
